import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

interface StatusBarChartProps {
  data: {
    name: string;
    value: number;
  }[];
}

export const StatusBarChart: React.FC<StatusBarChartProps> = ({ data }) => {
  const chartData = {
    labels: data.map(d => d.name),
    datasets: [
      {
        label: 'Count',
        data: data.map(d => d.value),
        backgroundColor: '#2394d2',
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'x' as const,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#2a2a2a',
        titleColor: '#ccc',
        bodyColor: '#fff',
        borderColor: '#444',
        borderWidth: 1,
        padding: 8,
        titleFont: { size: 12 },
        bodyFont: { size: 12 },
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#383838',
          maxRotation: 60,
          minRotation: 60,
        },
        grid: {
          color: '#e0e0e0',
        },
      },
      y: {
        ticks: {
          color: '#383838',
          stepSize: 1,
        },
        grid: {
          color: '#e0e0e0',
        },
        suggestedMin: 0,
      },
    },
  };

  return (
    <div className="h-100 w-100">
      <Bar data={chartData} options={options} />
    </div>
  );
};
